import { conditionalHooksFactory } from '@atlaskit/platform-feature-flags-react';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { createPlugin } from './pm-plugins/main';
import { pluginKey } from './pm-plugins/plugin-key';
import { useResizeWidthObserver, useResizeWidthObserverLegacy } from './ui/hooks/useResizeWidthObserver';
var useResizeWidthObserverHook = conditionalHooksFactory(function () {
  return editorExperiment('platform_editor_stop_width_reflows', true, {
    exposure: true
  });
}, useResizeWidthObserver, useResizeWidthObserverLegacy);

/**
 * Width plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */
export var widthPlugin = function widthPlugin() {
  return {
    name: 'width',
    pmPlugins: function pmPlugins() {
      return [{
        name: 'width',
        plugin: function plugin(_ref) {
          var dispatch = _ref.dispatch;
          return createPlugin(dispatch);
        }
      }];
    },
    getSharedState: function getSharedState(editorState) {
      if (!editorState) {
        return undefined;
      }
      return pluginKey.getState(editorState);
    },
    usePluginHook: useResizeWidthObserverHook
  };
};